<template>
    <span class="avatar">
        <img  @click="showModal = true" v-if="srcValue" :src="srcValue" class="circle responsive-img activator profile-avatar" height="80" />
        <div v-else class="white-text circle avatar-fallback" @click="showModal = true">
            <i class="card-profile-image material-icons circle">person</i>
        </div>

         <my-upload
            field="img"
            @crop-success="uploadSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="showModal"
            :width="300"
            :height="300"
            :url="url"
            :params="{name: 'avatar'}"
            :headers="headers"
            img-format="jpg"
            lang-type="pt-br"
        >
        </my-upload>
    </span>
</template>

<script>

import myUpload from 'vue-image-crop-upload';
import { getUrl } from '@/helpers/api';
import Auth from '@/store/auth';

export default {

    name: 'avatar',

    components: {myUpload},

    computed: {

        url() {
            return getUrl('cliente/upload-imagem/?cliente_id='+this.cliente.cliente_id);
        },

        headers() {
            return {
                Accept: 'application/json',
                Authorization: `Bearer ${Auth.state.api_token}`
            };
        }
    },

    data() {
        return {
            showModal: false,
            srcValue: this.src,
        }
    },

    methods: {
         cropUploadSuccess(jsonData, field){
        },
        cropUploadFail(status, field){
        },
        
        uploadSuccess(base64) {
            this.srcValue = base64;

            console.log(this.srcValue)
        }
    },
    

    props: {
        src: String,
        cliente: Object,
    }
}
</script>


<style lang="scss">
.avatar {
    display: inline-flex;
}

.avatar-fallback {
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    width: 150px;
    text-align: center;
    font-size: 12px;

    .card-profile-image {
        color: #cfcfcf;
        font-size: 5rem;
        text-align: center;
    }
}

.profile-avatar{
    height: 200px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/common/cliente/Avatar.vue